import Position from './position';
import * as PIXI from 'pixi.js';
import Ease from './ease';
import CollisionBounds from './collisionBounds';


export default class Layer {
	
	constructor(args) {
		this.system = args.system;
		let hw = this.system.screen.width/2;
		let hh = this.system.screen.height/2;
		this.scene = args.scene;
		this.camera = new Position();
		this.container = new PIXI.Container();
		this.container.eventMode = 'passive';
		this.scene.root.addChild(this.container);
		this.ease = new Ease();
		this.inverseZoom = 1;
		this.attachedLayers = []; // other layers that want to inherit camera position from this one
		this.attachedTo = null; // layer controlling this layer's camera position
		this.setCamera({x:hw, y:hh, scale:1});

		// bonus graphics object for debugging or general lolz
		this.g = new PIXI.Graphics();
		this.container.addChild(this.g);
	}

	update(delta, deltaNormal) {
		if(this.attachedTo) return;
		if(this.ease.update(delta, deltaNormal)) {
			this.updateCameraOffset();
		}
	}

	/**
	 * @param {Layer} layer attach a different layer from the scene to override its camera position with this one's
	 */
	attachLayer(layer) {
		layer.attachedTo = this;
		this.attachedLayers.push(layer);
	}

	setCamera(args) {
		if(this.attachedTo) return;
		if(args.x != undefined) this.camera.x = args.x;
		if(args.y != undefined) this.camera.y = args.y;
		if(args.scale != undefined) this.camera.scale = args.scale;
		this.updateCameraOffset();
	}

	easeCamera(args, duration=1000) {
		if(this.attachedTo) return;
		if(args.x == undefined) args.x = this.camera.x;
		if(args.y == undefined) args.y = this.camera.y;
		if(args.scale == undefined) args.scale = this.camera.scale;
		this.ease.go(this.camera, args, duration);
	}

	updateCameraOffset() {
		if(this.attachedTo) return;
		this.inverseZoom = 1/this.camera.scale;
		let hw = this.system.screen.width/2;
		let hh = this.system.screen.height/2;
		this.container.x = hw;
		this.container.y = hh;
		// PIXI ignores pivot values of zero :rolleyes: :facepalm:
		if(this.camera.x == 0) this.camera.x = 0.00000001;
		if(this.camera.y == 0) this.camera.y = 0.00000001;
		this.container.pivot.x = this.camera.x;
		this.container.pivot.y = this.camera.y;
		this.container.scale.set(this.camera.scale);
		this.updateAttachedLayers();
	}

	translateScreenCoords(c) {
		let hw = this.system.screen.width/2;
		let hh = this.system.screen.height/2;
		let iz = 1/this.camera.scale;
		let x = (c.x * iz) + this.camera.x - (hw * iz);
		let y = (c.y * iz) + this.camera.y - (hh * iz);
		return {x:x, y:y}
	}

	updateAttachedLayers() {
		for(let l of this.attachedLayers) {
			l.inverseZoom = this.inverseZoom;
			l.camera.x = this.camera.x;
			l.camera.y = this.camera.y;
			l.camera.scale = this.camera.scale;
			l.container.x = this.container.x;
			l.container.y = this.container.y;
			l.container.pivot.x = this.container.pivot.x;
			l.container.pivot.y = this.container.pivot.y;
			l.container.scale.set(this.camera.scale);
		}
	}

	getVisibleBounds() {
		// find extent of visible area on screen at current camera zoom/pan
		let tl = this.translateScreenCoords({x:0, y:0});
		let br = this.translateScreenCoords({x:this.system.screen.width, y:this.system.screen.height});
		return new CollisionBounds({ t: tl.y, r: br.x, b: br.y, l: tl.x });
	}

	destroy() {
		this.scene.root.removeChild(this.container);
		this.container = null;
	}


}